import { User } from "@root/router/dialogue/chat-threads/user.model";
import * as moment from "moment";
export class Thread {
  id: string;
  unread_count: number;
  house_title: string;
  title_alias: string;
  text_preview: string;
  last_message_time: string;
  tenant_info: User;
  host_info: User;
  thirdparty_type: number;
  zhenguo_docking: boolean;
  is_top: number;
  [props: string]: any;
  constructor(options?: any) {
    for (let key in options) {
      this[key] = options[key];
    }

    // this.id = options.id || '';
    // this.unread_count = options.unread_count || 0;
    // this.house_title = options.house_title || '';
    // this.title_alias = options.title_alias || '';
    // this.text_preview = options.text_preview || '';
    // this.tenant_info =
    //   options.tenant_info || null;
    // this.host_info = options.host_info || null;
    // this.last_message_time = options.last_message_time || '';
    // this.thirdparty_type = options.thirdparty_type || 0;
    // this.zhenguo_docking = options.zhenguo_docking || false;
  }

  markAsRead() {
    this.unread_count = 0;
  }

  merge(props: Object) {
    for (let p in props) {
      this[p] = props[p];
    }
  }

  // get relative_time() {
  //   const time = moment(this.last_message_time);
  //   if (time.isSame(moment(), 'day')) {
  //     return time.format('HH:mm');
  //   } else {
  //     return time.format('MM-DD');
  //   }
  // }
}
